import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { applyPanel } from "../ui/UiPanel";
export default function AdminRegisterPage({ token, onSuccess }) {
    const [groupLabel, setGroupLabel] = useState("Lade Gruppeninfo...");
    const [groupError, setGroupError] = useState(false);
    const [ready, setReady] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const boxRef = useRef(null);
    useEffect(() => {
        if (boxRef.current)
            applyPanel(boxRef.current, "beigeLight");
    }, []);
    useEffect(() => {
        void fetch(`/api/invite/admin-token/${encodeURIComponent(token)}`)
            .then(async (res) => {
            if (!res.ok) {
                const err = (await res.json());
                setGroupLabel(err.error ?? "Ungültiger Token");
                setGroupError(true);
                return;
            }
            const data = (await res.json());
            setGroupLabel(`Gruppe: ${data.displayName}`);
            setReady(true);
        })
            .catch(() => {
            setGroupLabel("Token konnte nicht geprüft werden");
            setGroupError(true);
        });
    }, [token]);
    async function submit() {
        setError("");
        setLoading(true);
        try {
            const res = await fetch("/api/invite/admin-register", {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token, name, email, password }),
            });
            if (!res.ok) {
                const err = (await res.json());
                throw new Error(err.error ?? "Registrierung fehlgeschlagen");
            }
            onSuccess();
        }
        catch (e) {
            setError(e instanceof Error ? e.message : "Fehler");
            setLoading(false);
        }
    }
    return (_jsxs("div", { className: "min-h-screen bg-lime-700 flex items-center justify-center font-sans", children: [_jsx("img", { src: "/assets/images/gpt-stolpen.webp", alt: "Background image: Stolpen", className: "absolute top-0 left-0 w-full h-full object-cover z-0 blur-sm" }), _jsxs("div", { ref: boxRef, className: "relative z-10 p-8 w-[360px] flex flex-col gap-4 shadow-sm", children: [_jsxs("div", { children: [_jsx("h1", { className: "text-xl font-bold text-slate-900 m-0", children: "Dein GO! City" }), _jsx("p", { className: `text-sm mt-1 ${groupError ? "text-red-700" : "text-slate-600"}`, children: groupLabel })] }), _jsxs("div", { className: "flex flex-col gap-1", children: [_jsx("label", { className: "text-xs font-medium text-slate-600", children: "Name" }), _jsx("input", { type: "text", value: name, onChange: (e) => setName(e.target.value), placeholder: "Dein Name", className: "w-full px-3 py-2 border border-[#7d6650] rounded-lg text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-500" })] }), _jsxs("div", { className: "flex flex-col gap-1", children: [_jsx("label", { className: "text-xs font-medium text-slate-600", children: "E-Mail" }), _jsx("input", { type: "email", value: email, onChange: (e) => setEmail(e.target.value), placeholder: "deine@email.de", className: "w-full px-3 py-2 border border-[#7d6650] rounded-lg text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-500" })] }), _jsxs("div", { className: "flex flex-col gap-1", children: [_jsx("label", { className: "text-xs font-medium text-slate-600", children: "Passwort" }), _jsx("input", { type: "password", value: password, onChange: (e) => setPassword(e.target.value), placeholder: "Mindestens 8 Zeichen", className: "w-full px-3 py-2 border border-[#7d6650] rounded-lg text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-500" })] }), _jsx("p", { className: "text-red-700 text-xs min-h-[1rem] m-0", children: error }), _jsx("button", { onClick: () => void submit(), disabled: !ready || loading, className: "w-full py-2 bg-lime-400 border-transparent border hover:bg-lime-300 hover:border-lime-400 text-black font-medium rounded-lg cursor-pointer text-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed", children: "Als Gruppenadmin registrieren" })] })] }));
}
